/**
 * Created by Languagenut on 22/03/2019.
 */


import React  from 'react';
import {Card , Row , Col} from 'react-bootstrap'
import {Lessons , SongsStories , SectionMenu , FavoriteButton} from '../components';
import Translation from '../store/internationalization-store.js';
import {Overview} from '../components/custom_content';
import Map from '../components/library/content.js'
import Printables from '../components/library/printables.js';
import LanguagenutPackage from '../classes/package.js';
import Certificates from '../components/library/certificates.js'
export default class Library extends React.Component {

    constructor(props) {
        super();
        this.props = props;

        if((new LanguagenutPackage()).isSecondary())
        {
            this.state = {
                "tab":this.props.match.params.tab,
                additionalContentItems:[

                ],
                personalItems:[
                    {id:"custom_content" , name:Translation.get(12207 , 'Custom Content')    , disabled:false},
                    {id:"content_map" , name:Translation.get(123 , 'Content Map') , disabled:false},
                ],
            };
        }
        else
        {
            var songsAndStores = false;
            this.state = {
                "tab":this.props.match.params.tab,
                additionalContentItems:[

                ],
                personalItems:[
                    {id:"custom_content" , name:Translation.get(12207 , 'Custom Content')    , disabled:false},
                    {id:"printables" , name:Translation.get(330 , 'Printable Resources') , disabled:false},
                    {id:"content_map" , name:Translation.get(123 , 'Content Map') , disabled:false},
                    {id:"songs" , name:Translation.get(101 , 'Songs & Stories')    , disabled:songsAndStores},
                    {id:"lessons" , name:Translation.get(791 , 'Lesson Plans')    , disabled:songsAndStores}
                   /* {id:"certificates_and_rewards" , name:Translation.get(-1 , 'Certificates and rewards')    , disabled:false},*/
                ],
            };
        }

    }

    componentDidMount() {


    }

    componentWillReceiveProps(props){

    }

    onNavigationSelect(eventKey){
        window.location.hash = "library/"+eventKey;
    }

    componentWillReceiveProps(props){
        this.props = props;
        this.setState({
            tab:this.props.match.params.tab,
        })
    }

    getBody(){

        switch(this.state.tab)
        {
            case "printables" : return <Printables/>
            case "custom_content" : return <Overview/>
            case "lessons" : return <Lessons/>
            case "stories" : return <SongsStories/>
            case "songs" : return <SongsStories/>
            case "content_map" : return <Map />
            case "certificates_and_rewards" : return <Certificates />
            default: return null;
        }
    }

    render(){

        return <div>
                    <Row>
                        <Col sm={2} md={3}>
                            <SectionMenu selected={this.state.tab} hasHeader={false} title={"Personalised Resources"} items={this.state.personalItems} onSelect={this.onNavigationSelect.bind(this)} />
                        </Col>
                        <Col sm={10} md={9}>
                            <Card body>
                                {this.getBody()}
                            </Card>
                        </Col>
                    </Row>
                </div>


    }

}